<template>
    <div class="app-container">
    <el-form ref="form" :model="form" label-width="110px">
        <el-form-item v-show="showInput" label="详细地址：" prop="address">
        <el-autocomplete
            v-model="form.address"
            style="width:100%;"
            popper-class="autoAddressClass"
            :fetch-suggestions="querySearchAsync"
            :trigger-on-focus="false"
            placeholder="请输入要查询的地址"
            clearable
            @select="handleSelect"
            >
            <template slot-scope="{ item }">
            <i class="el-icon-search fl mgr10" />
            <div style="overflow:hidden;">
                <div class="title">{{ item.title }}</div>
                <span class="address ellipsis">{{ item.address }}</span>
            </div>
            </template>
        </el-autocomplete>
        </el-form-item>
        <el-form-item label="地图定位：">
            <div id="map-container" style="width:100%;height:500px;" />
        </el-form-item>
        <el-form-item v-show="showInput">
        <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
    </el-form>
    </div>
</template>

<script>
/* eslint-disable */
import loadBMap from '@/utils/loadBMap.js'
import state from '@/utils/shareState.js'
export default {
  props:{'mapInfo':String,'addType':String,'mapNum':String},
  data() {
    return {
      state,
      showInput: true,
      form: {
        address: '', // 详细地址
        addrPoint: { // 详细地址经纬度
          lng: 0,
          lat: 0
        }
      },
      map: '', // 地图实例
      mk: '', // Marker实例
      locationPoint: null
    }
  },
  async mounted() {
    await loadBMap('uAF79SCIEdLFbymRudmCdwsQvKhxl0wX') // 加载引入BMap
    this.initMap()
    // if(this.mapNum == '1'){
    //   this.showInput = false
    // }else{
    //   this.showInput = true
    // }
  },
  watch:{
    mapNum(){
      this.initMap()
    }
  },
  methods: {
    // 初始化地图
    initMap() {
      var that = this

      // 1、挂载地图
      this.map = new BMap.Map('map-container', { enableMapClick: false })
      let lng = this.mapInfo.split(',')[0]
      let lat = this.mapInfo.split(',')[1]
      var point = new BMap.Point(lng, lat)
      this.map.centerAndZoom(point, 14)
      // 3、设置图像标注并绑定拖拽标注结束后事件
      this.mk = new BMap.Marker(point, { enableDragging: true })
      this.map.addOverlay(this.mk)
      this.mk.addEventListener('dragend', function(e) {
        that.getAddrByPoint(e.point)
      })

      // 4、添加（右上角）平移缩放控件
      this.map.addControl(new BMap.NavigationControl({ anchor: BMAP_ANCHOR_TOP_RIGHT, type: BMAP_NAVIGATION_CONTROL_SMALL }))

      // 5、添加（左下角）定位控件
      var geolocationControl = new BMap.GeolocationControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT })
      geolocationControl.addEventListener('locationSuccess', function(e) {
        that.getAddrByPoint(e.point)
      })
      geolocationControl.addEventListener('locationError', function(e) {
        alert(e.message)
      })
      this.map.addControl(geolocationControl)

      // 6、浏览器定位
     // this.geolocation()

      // 7、绑定点击地图任意点事件
      this.map.addEventListener('click', function(e) {
        that.getAddrByPoint(e.point)
      })
    },
    // 获取两点间的距离
    getDistancs(pointA, pointB) {
      return this.map.getDistance(pointA, pointB).toFixed(2)
    },
    // 浏览器定位函数
    geolocation() {
      var that = this
      var geolocation = new BMap.Geolocation()
      geolocation.getCurrentPosition(function(res) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          that.getAddrByPoint(res.point)
          that.locationPoint = res.point
        } else {
          alert('failed' + this.getStatus())
          that.locationPoint = new BMap.Point(116.403963,39.915119)
        }
      }, { enableHighAccuracy: true })
    },
    // 2、逆地址解析函数
    getAddrByPoint(point) {
      var that = this
      var geco = new BMap.Geocoder()
      geco.getLocation(point, function(res) {
        // console.log(res)
        that.mk.setPosition(point)
        that.map.panTo(point)
        that.form.address = res.addres
        that.form.addrPoint.lng = point.lng
        that.form.addrPoint.lat = point.lat
      })
    },
    // 8-1、地址搜索
    querySearchAsync(str, cb) {
      var options = {
        onSearchComplete: function(res) {
          var s = []
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            for (var i = 0; i < res.getCurrentNumPois(); i++) {
              s.push(res.getPoi(i))
            }
            cb(s)
          } else {
            cb(s)
          }
        }
      }
      var local = new BMap.LocalSearch(this.map, options)
      local.search(str)
    },
    // 8-2、选择地址
    handleSelect(item) {
      this.form.address = item.address + item.title
      this.state.setMapInfo(item)
      this.form.addrPoint = item.point
      this.map.clearOverlays()
      this.mk = new BMap.Marker(item.point)
      this.map.addOverlay(this.mk)
      this.map.panTo(item.point)
    },
    onSubmit() {
      if(this.form.addrPoint.lat === 0&&this.form.addrPoint.lng === 0){
        this.$message.warning('请您输入添加的查询地址')
        return
      }
      this.$parent.$parent.close()
    }
  }
}
</script>

<style lang="less" scoped>
  .autoAddressClass{
    li {
      i.el-icon-search {margin-top:11px;}
      .mgr10 {margin-right: 10px;}
      .title {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .address {
        line-height: 1;
        font-size: 12px;
        color: #b4b4b4;
        margin-bottom: 5px;
      }
    }
  }
    .el-button--primary {
        color: #FFF;
        background-color: @primary-color;
        border-color: @primary-color;
    }
</style>

